<template>
  <!-- this is an example of a dynamic template. -->
  <!-- Your dynamic content is exposed as 'content' data property in the template. -->
  <div class="smile-page"> 
    <div class="smile-header-image">
      <content-image :src="item.Image" :fieldClass="'responsive-image'"/>
      <div :class="route + '-section-details'">
          <h1 v-if="item.Title">{{item.Title}}</h1>
          <div class="smile-hero-text"  v-if="item.herotext">
            <p>{{item.herotext}}</p>
          </div>
          <div class="learn-more-container">
            <a class="learn-more-button" href="#">Learn More</a>
          </div>
        </div>
    </div>
    <div class="container">
      <div class="clearfix">
        <div class="">
          <div v-if="!currentContent">
            <div class="body">Loading...</div>
          </div>
          <div v-else >
            <div class="smile-section-image" v-if="item.SectionImage">
              <img :src="item.SectionImage" :alt='item.Title + "Section Image"'/>
            </div>
            <div class="intro_container">
              <div class="smile-section">
                <h3 class="smile-intro-text" v-if="item.IntroText">{{item.IntroText}}</h3>
              </div>
            </div>
            <div class="smile-content">
              <content-body v-if="item.PageContent" :fieldClass="'body'" :body="item.PageContent"/>
                <div class="smile-intro-image" v-if="item.IntroImage">
                  <img :src="item.IntroImage" :alt='item.Title + "Intro Image"'/>
                </div>
            </div>  
            <section class="cards">
              <div class="smile-card">
                <h2>Previous Projects</h2>
                <img src="../assets/img/previousProjectHome.png" :alt='item.Title + "Intro Image"'/>
                <a href="/previousprojects">Find Out More!</a>
              </div>
              <div class="smile-card">
                <h2>About Smile</h2>
                <img src="../assets/img/aboutProjectHome.png" :alt='item.Title + "Intro Image"'/>
                <a href="/about-smile">Find Out More!</a>
              </div>
              <div class="smile-card">
                <h2>Smile News</h2>
                <img src="../assets/img/newProjectHome.png" :alt='item.Title + "Intro Image"'/>
                <a href="/smile-news">Find Out More!</a>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadContent from './LoadContent'
import Title from '@/app/fieldTemplates/Title.vue'
import Image from '@/app/fieldTemplates/Image.vue'
import Body from '@/app/fieldTemplates/Body.vue'
import _ from 'lodash'

export default {
  mixins: [LoadContent],
  components: {
    contentTitle: Title,
    contentImage: Image,
    contentBody: Body
  },
  data() {
    return {
      item:{
        IntroImage: '',
        IntroText: '',
        PageContent: '',
        Title: ''
      },
      route: '',
      contact:false
    }
  },
  mounted() {},
  computed: {
    currentContent () {
      
      for(var i = 0; i < this.content.length; i++)
      {
        if(this.$route.path === '/'+this.content[i].slug)
        {
          this.item = this.content[i];
          this.route = this.content[i].slug
          console.log(this.item);
          if(this.$route.path === '/contact-us')
          {
            this.contact = true;
          }
          console.log(this.contact);
        }
      }
      return this.content;
    }
  },
  methods: {
   
  }
}
</script>

<style lang="scss">
@import '@/app/styles/index.scss';
.smile-section{
  // padding-top:30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    max-width: 1200px;
    margin: 40px auto;

}
.intro_container{
  max-width: 1440px;
    margin: auto;
    background-color:$color-smile-green;
    padding:60px 20px;
    
}
.smile-intro-text{
    font-size: 25px;
    margin:40px 0;
    color:white !important;
    flex:2 2 20em;
    flex-grow: 1;
    line-height: 2;
    text-align: center;
  }
.smile-section-details{
  position:absolute;
 top: 0;
    bottom: 0;
    left: 0;
    right: 0;

  display: flex;
  flex-direction:column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  h1{
        font-size: 80px;
        margin:0;
        color:white;
  }
  
  .smile-hero-text{
    font-size: 25px;
    margin:20px 0;
    color:white;
  }
}
.smile-section-image{
  padding: 60px 0 ;
  max-width:80%;
  margin:auto;
}
.smile-header-image{
  position:relative;
  // padding:20px;
    // max-width: 900px;
    margin: auto;
    display:flex;
    flex-wrap:wrap;
    max-width:1440px;
    
}
.smile-intro-image{
  max-width:400px;
  flex:1 1 20em;
    // flex-grow: 1;
    img{
          width: 100%;
    display: flex;
    }
}
.learn-more-button {
  //  margin:10px;
  border:solid 6px white;
  // background-color:$color-smile-pink;
  color:white;
      padding: 10px 20px;
  border-radius: 10px;
  display:inline-block;
  
    font-size: 22px;

}
.smile-content{
    padding:100px 20px;
    max-width: 1200px;
    margin: auto;
    font-size: 20px;
    display: flex;
    flex-wrap: wrap;
    .body{
      flex: 2 2 20px;
      padding: 25px;

    }
}
.smile-card{
  position:relative;
  flex: 2 2 20em;
  margin-left: 30px;
  width: auto;
  // max-width: 900px;
  text-align: right;
  height: auto;
  flex-grow: 1;
  border-top:Solid 10px $color-smile-pink;
  display: flex;
  flex-direction: column;
  box-shadow: #00000021 0px 4px 20px 0px;

  h2{
    padding-top:10px;
    text-align: left;
    font-size: 30px;
    font-weight: 600;
    padding: 10px;
  }

  a {
     box-shadow: #00000075 -6px -5px 9px 0px;

    position:absolute;
    bottom:0;
    right:0;
    background:$color-smile-pink;
    color:white;
    padding:10px 20px;
    
    
  }
}
.cards{
  max-width:1200px;
  padding-bottom: 40px ;
}
@media(max-width: 850px) {
  .smile-section-details{
    h1{
      font-size: 70px;
    }
    .smile-hero-text{
      font-size: 20px;
      margin:0;
    }
  }
  .learn-more-button {
     border: solid 4px white;
    padding: 10px 20px;
    font-size: 18px;
        margin: 10px;

}
}
@media(max-width: 600px) {
  .smile-section-details{
    position:relative;
    text-align:center;
    background:$color-smile-green;
    padding: 20px 10px;
    width:100%;
  }
}
@media(max-width: 450px) {
  .smile-section-details{
      h1{
        font-size: 50px;
      }
      .smile-hero-text{
        font-size: 17px;
      }
    }
  .learn-more-button {
    padding: 8px 16px;
    font-size: 15px;
  }
  .smile-section-image{
    max-width:90%;
  }
}
@media(max-width: 425px) {
  .smile-section-details{
  
    h1{
      font-size: 50px;
    }
    
    .smile-hero-text{
      font-size: 17px;
      margin:0;
    }
  }
  .learn-more-button {
    padding: 8px 16px;
    font-size: 15px;

}
.smile-section-image{
  max-width:90%;
}
}

</style>

